<template>
  <el-dialog
    title="编辑热区"
    :visible="value"
    @close="closeDialog"
    :append-to-body="true"
    width="800px"
    class="hotSpotBg"
  >
    <EditHotSpotDialogSection v-model="hotSpots" :imgUrl="item.imgUrl" />
    <div class="dialog-footer">
      <el-button class="cancel" @click="closeDialog">取 消</el-button>
      <el-button class="confirm" @click="confirm">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { deepCopy } from "../../../../utils/utils";
import EditHotSpotDialogSection from "./EditHotSpotDialogSection";
export default {
  components: {
    EditHotSpotDialogSection
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      hotSpots: []
    };
  },
  mounted() {
    this.hotSpots = deepCopy(this.item).hotSpots;
  },
  methods: {
    closeDialog() {
      this.$emit("input", false);
    },
    confirm() {
      this.$emit("confirm", this.hotSpots);
      this.closeDialog();
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog {
  .dialog-footer {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 15px;
    padding-top: 30px;
    .el-button {
      padding: 4px 14px;
      color: #000000;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      border: none;
    }
    .cancel {
      background: #e7eaec;
    }
    .confirm {
      color: #fff;
      background: #2154f4;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/custom-component/baseComponents/HotSpot/components/EditHotSpotDialog.vue